import React, { createContext, useContext } from "react";
import { useNotifications } from "../hooks/websocket/useSocket";
import { Notification } from "../types/notification.interface";

interface NotificationContextValue {
  lastNotification: Notification | undefined;
  isConnected: boolean;
}

const NotificationContext = createContext<NotificationContextValue | undefined>(
  undefined,
);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { notificationsSocket, isConnected } = useNotifications();

  return (
    <NotificationContext.Provider
      value={{ lastNotification: notificationsSocket, isConnected }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = (): NotificationContextValue => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within NotificationProvider",
    );
  }
  return context;
};
